

export default {

    created() {

        let t = this;
        
        t.checkSignIn();
    },
    activated() {

        let t = this;

        t.checkSignIn();
    },
    unmounted() {
    },
    methods: {

        enterAsLandlord(item) {
            localStorage.removeItem('_m');
            localStorage['_landlord'] = JSON.stringify(item);
            if (item && item.token) {
                axios.defaults.headers.common['Token'] = item.token;
            }
            location.replace('/#/owner');
        },

        enterAsEmployee(user) {
            localStorage.removeItem('_landlord');
            localStorage['_m'] = JSON.stringify(user);
            this.afterLogin();

            if (user.is_mgr == 1) {
                if (document.documentElement.offsetWidth <= 760)
                    location.replace('/#/employee');
                else
                    location.replace('/#/monitor');
            }
            else if (user.role == 4) {
                location.replace('/#/employee');
            }
            else if (user.role == 2 || user.role == 3 || user.role == 5) {
                location.replace('/#/cleaner');
            }
        },

        checkSignIn() {

            var landlord = null;
            try {
                landlord = JSON.parse(localStorage['_landlord'] || 'null');
            } catch (e) {
                landlord = null;
            }
            if (landlord && landlord.token) {
                location.replace('/#/owner');
                return;
            }

            if (localStorage['_m']) {

                let user = JSON.parse(localStorage['_m']);

                if (user.is_mgr == 1) {
                    if (document.documentElement.offsetWidth <= 760)
                        location.replace('/#/employee');
                    else
                        location.replace('/#/monitor');
                }
                else if (user.role == 4) {
                    location.replace('/#/employee');
                }
                else if (user.role == 2 ) {
                    location.replace('/#/cleaner');
                }

            }


        },

        signIn() {
            let t = this;
            let f = t.f;

            if (t.busying)
                return;

            mirror(t.msg_o, t.msg);

            let go = true;

            if (!f.email) {
                t.msg.email = 'Required';
                go = false;
            }

            if (!f.password) {
                t.msg.password = 'Required';
                go = false;
            }

            if (!go)
                return;


            t.busying = true;

            axios.post('employee/signIn', f).then(res => {

                if (res.data.status == 1) {
                    t.busying = false;
                    t.enterAsEmployee(res.data.options.item);
                    return;
                }

                if (res.data.status == 2) {
                    axios.post('landlord/signIn', f).then(res2 => {
                        t.busying = false;
                        if (res2.data.status == 1 && res2.data.options && res2.data.options.kind == 'landlord') {
                            t.enterAsLandlord(res2.data.options.item);
                        } else {
                            A.err('Email or password incorrect, please check.');
                        }
                    }).catch(function () {
                        t.busying = false;
                        A.err('Email or password incorrect, please check.');
                    });
                    return;
                }

                t.busying = false;
                A.err('Email or password incorrect, please check.');

            }).catch(function () {
                t.busying = false;
                A.err('Email or password incorrect, please check.');
            });

        }
    },
    data() {
        return {
            msg: {
                email: '',
                password: '',
            },
            msg_o: {
                email: '',
                password: '',
            },
            f: {
                email: '',
                password: '',
            },

            list: {
            },

        };
    },
};
